import { Component, HostListener, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {Collabo} from './collabo';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common'
import {LoginService} from '../../login-service';
import { filter } from 'rxjs/operators';
import { HashLocationStrategy } from '@angular/common';
import {SocialLogins} from '../../sociallogins';
import { ImageuploadService } from '../../Imageupload.service';

@Component({
  selector: 'app-postcollabo',
  templateUrl: './postcollabo.component.html',
  providers:[Collabo,SocialLogins,DatePipe]
})
export class PostcollaboComponent implements OnInit {
  matcategory:boolean=false;
  tagselect:boolean=false;
  hoursFulltotal: any=[];
  specificbudgeterror=false;
  // param:string
collaboActorDetails:any;
saveCollaboJson:any;
displayfilename:boolean=false;
statusidParam:string;

displayfilename1:boolean=false;
display:boolean=true;
aboutcollabo:boolean;
legalcollabo:boolean;
  selectedActorNames:any=[];
  
  selectedList:any=[];
  parentcollaboid:string;
    tabtype:string;
    categorysList:any;
    subCategorysList:any;
    skilsList:any;
    
errorMessage:string;
//AboutCollabo 
collaboName:string;
collaboDescription:string;
optionalTags:string;
categoryID:string;
// subCategoryID:string;
// subCategoryID=[];
subCategoryID: number[] 
processName = [];
skillID:string;
TitleName:string;
collaboPath:any;

//time nad factors
regionName:string;
startDate=new Date();
endDate=new Date();
projectPeriod:string;
specificTimeLine:string;
filename:string;
payValue:string;
//Budget
expectedBudget:string;
totalPercentageValues=0;
specificBudget:any;
selectedFiles:any=[];
filePathList=[];
CollabosList:any;
filterPercentages=[];
//legal documents
uploadLegalDocuments:any;

fileToUpload: File = null;
image:any;
chkValue:any;
selectedRows:any;
actorsList:any;
checkid:string;
checkvalue:any;
ActorID:string
actorName:any;
jsonList:any=[];
selectedactorsList:any=[];
collaboID:string;
chkPercent:any;
chkFees:any;
type:string;
cid:string;
newDynamic: any = {};
dynamicArray: Array<Collabo> = [];
xyz:boolean;
selectedActors=[];
perentagefeesList:any=[];
error: string;
  dragAreaClass: string;
    localUrl: any;
    currentInput:any;
    FileUpload:any;
    userType:string;

    butonType:any;
      userID: string;
  
  actorIdList: any;
  imagefile1: any;
  imagefile: void;
  typeoffile: any;
  filename1: string;
  todayDate: any;
  hourtotal: any=[];
  totalhours:any=[];
  hoursfee:any;
  totalhouramt: number=0;
  
  totalfixedamt:number=0;
  totalpercentamt:number=0;
  postcollabo:boolean=false;
  checkpercentage: boolean=false;
  checkpercentagesum: boolean=false;
  checkbudget: boolean=false;
  totalamounterror: boolean;
  checkdynamicarray: boolean=false;
  percentselect: boolean=false;
  priceselect: boolean=false;
  hourselect: boolean=false;
  onFileSelected(event) {
    this.currentInput = event.target.files; 
  }

  
  // onFileChange(event: any) {
  //   let files: FileList = event.target.files;
  //   this.collaboPath=event.target.value;
  //   this.saveFiles(files);
  // }


    constructor(public datepipe: DatePipe,private loginService:LoginService,public imageservice: ImageuploadService,private collabo:Collabo,private router:Router,private activateRoute:ActivatedRoute,private  sl :SocialLogins) {
      this.userID=localStorage.getItem('USERID');
      this.collaboID = this.activateRoute.snapshot.params['collaboID'];
      
     
      // public datepipe: DatePipe,
       var date = new Date();
       this.todayDate = this. datepipe. transform(date, 'yyyy-MM-dd');
       console.log(this.todayDate)
     }
     tabStepsChange(steps){
       this.tabtype=steps;
     }
    ngOnInit() {
      this.aboutcollabo=true;
      this.typeoffile="Collabo"
        this.tabtype='step1';
        this.GetCategorysByParentID(0);
        this.GetCollabos();
        this.GetSkills();
        this.GetActors();

 this.dragAreaClass = "dragarea";
 if(this.regionName==""||this.TitleName=="")
 {
   this.xyz=false;
 }
 else{
  this.xyz=true;
 }
  
     }
     view(doc)
{
  console.log("clicked");
  console.log(doc)
  window.open(this.loginService.imageURL+doc);
}
 closefile()
 {
   this.displayfilename=false;
   this.displayfilename1=false;
 }
    // fileChange(input,param) {
    //   this.displayfilename=true;
    //   this.displayfilename1=true;
    //   this.filename=input.files[0].name
    //   // this.FacilityTypeLogo="";
    //   console.log(param);
    //   this.imagefile = this.loginService.filechange(input, param,"");
    //   console.log(this.imagefile);
    //   // if(param=="Collabo")
    //   // {
    //   //   console.log("collabo param")
    //   this.imageservice.ImageUplode.subscribe(Img => this.collaboPath = Img);
      
    //   // }
    //   // else if(param.toString()=="Legaldocuments"){
    //   //   console.log("legaldocuments param")
    //   // this.imageservice.ImageUplode.subscribe(Img => this.uploadLegalDocuments = Img);
    //   // }
      
    //   console.log(this.collaboPath);
    //   // console.log(this.uploadLegalDocuments)


    // }
    // fileChange1(input,param) {
    
    //   // this.FacilityTypeLogo="";
    //   console.log(param);
    //   this.imagefile = this.loginService.filechange1(input, param,"");
    //   console.log(this.imagefile);
    //   // if(param=="Collabo")
    //   // {
    //   //   console.log("collabo param")
    //   this.imageservice.ImageUplode1.subscribe(Img => this.uploadLegalDocuments = Img);
      
    //   // }
    //   // else if(param.toString()=="Legaldocuments"){
    //   //   console.log("legaldocuments param")
    //   // this.imageservice.ImageUplode.subscribe(Img => this.uploadLegalDocuments = Img);
    //   // }
    //   //console.log(this.collaboPath);
    //    console.log(this.uploadLegalDocuments)


    // }

    
    fileChange(input,param) {
      this.displayfilename=true;
      this.displayfilename1=true;
      this.filename=input.files[0].name
      // this.FacilityTypeLogo="";
      console.log()
      console.log(param);
      this.imagefile = this.loginService.filechange(input, param,this.userID);
      console.log(this.imagefile);
      // if(param=="Collabo")
      // {
      //   console.log("collabo param")
       this.collaboPath='Images/Collabo/'+this.userID+'/'+this.filename
       console.log(this.collaboPath)
       localStorage.setItem('collabopath',this.collaboPath);
         



    }
    fileChange1(input,param) {
      this.displayfilename=true;
      this.displayfilename1=true;
      this.filename1=input.files[0].name
      // this.FacilityTypeLogo="";
      console.log(param);
      this.imagefile = this.loginService.filechange1(input, param,this.userID);
      console.log(this.imagefile);
      // if(param=="Collabo")
      // {
      //   console.log("collabo param")
      this.imageservice.ImageUplode1.subscribe();
        this.uploadLegalDocuments='Images/Legaldocuments/'+this.userID+'/'+this.filename1
        console.log(this.uploadLegalDocuments)
        localStorage.setItem('uploadlegaldocuments',this.uploadLegalDocuments);

      // }
      // else if(param.toString()=="Legaldocuments"){
      //   console.log("legaldocuments param")
      // this.imageservice.ImageUplode.subscribe(Img => this.uploadLegalDocuments = Img);
      // }
      //console.log(this.collaboPath);
       console.log(this.uploadLegalDocuments)


    }


     
     handleFileInput(event) {
      let files: FileList = event.target.files;
      this.fileToUpload = files.item(0);
      this.uploadFileToActivity();
      
  }
  uploadFileToActivity() {
    this.loginService.upload(this.fileToUpload).subscribe(data => {
     console.log(data);
      // do something, if upload success
      }, error => {
        console.log(error);
      });
  }
  //Collabo Details 
  GetCollabos(){
    this.loginService.GetCollabos(1).subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.CollabosList=JSON.parse(JSON.stringify(data));
console.log(this.CollabosList);
      this.loginService.GetCollaboActorDetails().subscribe(data1=>{
        data1 = JSON.parse(data1['_body']);
      this.collaboActorDetails=JSON.parse(JSON.stringify(data1));
      
    
   })
  })
  }
  //skills list details
     GetSkills(){
         this.loginService.Getskills(1).subscribe(data=>{
            data = JSON.parse(data['_body']);
            this.skilsList=JSON.parse(JSON.stringify(data));
            console.log(this.skilsList);
         })
     }
     //Displaying actor details
     GetActors(){
         this.loginService.GetActors().subscribe(data=>
            {
                data = JSON.parse(data['_body']);
                this.actorsList=JSON.parse(JSON.stringify(data));
                console.log(this.actorsList)
            })
     }

     //Saving actors
     InsertActors(){
       console.log(this.actorName);
       if(this.actorName==""||this.actorName==undefined)
       {
         return;
       }
       this.newDynamic = {
        id:0,
        name:this.actorName,
     numberType:"",
     description:"",
     percent:"",
     fees:"",
    hours:"",
      };
      console.log(this.newDynamic)
     this.dynamicArray.push(this.newDynamic);
     if(this.dynamicArray.length>0)
     {
       this.display=false;
     }
    this.actorName=""
      //  const json={
      //    id:"",
      //    name:this.actorName,
      //    createdby:"Initiator",
      //    updatedby:"Initiator",
      //  }
       
      //  this.loginService.InsertActors(json).subscribe((dataJson) => {
      
      //   if (dataJson['_body'].toString()!= '0') {
      //     this.GetActors();
      //     this.selectedActorNames=[];
      //     this.selectedActorNames.push(dataJson['_body'].toString()); 
      //     this.getSelectedActors();
      //   //  Swal.fire("saved successfully");
        
      //   // this.selectedList.push(dataJson['_body'].toString());
         
      //    this.actorName='';
      //   }
      
      // });
     // this.getSelectedActors();
      
     }
     getSelectedActors(){
       this.matcategory=true;
      this.loginService.GetActors().subscribe(data=>
        {
            data = JSON.parse(data['_body']);
            this.actorsList=JSON.parse(JSON.stringify(data));

       this.GetActors();
       this.newDynamic=[];
       this.dynamicArray=[];
      // this.selectedActorNames=[];

       if(this.selectedActorNames.length>0)
       {
        this.selectedList.push(JSON.parse(this.selectedActorNames));
     
          }  
          this.selectedActorNames=[];
        
for(let i=0;i<this.selectedList.length;i++)
{
  let filterActors=this.subCategorysList.filter(x=>x.id===this.selectedList[i]); 
  if(filterActors.length>0)

  this.newDynamic = {
    id:this.selectedList[i],
    name:filterActors[0].category,
 numberType:"",
 description:"",
 percent:"",
 fees:"",
hours:"",
  };
  console.log(this.newDynamic);
 this.dynamicArray.push(this.newDynamic);
 console.log(this.dynamicArray.length);
 if(this.dynamicArray.length>0)
 {
   this.display=false;
 }
 
}
      
      })
     }
     //Displaying selected skills
     getSelectedSkills(){
      this.tagselect=true;
       this.skillID=this.optionalTags;
     }
     
    //  changeListener(event:any) {
    //   let files: FileList = event.target.files;
    //   const condition = 0;
    //   let internalError = '';
    //   if (files && files.length > 0) {
        
    //     const file: File = files.item(0);
    //     const formData = new FormData(); 
        
    //     // Store form name as "file" with file data
    //     formData.append("file", file, file.name);
    //     this.collaboPath=formData;
//         this.loginService.upload(file).subscribe(data=>
//           {
// console.log(data);
//           });
    //   }
     

    // this.selectedFiles.push(files);
   
    // }
     skillsChange(event)
     {
this.skillID=event.value;

let filterSkills=this.skilsList.filter(x=>x.id==this.skillID)
if(filterSkills.length>0)
{
    
    this.optionalTags=filterSkills[0].skillsname;
}

     }

    
  //Displaying list of categorys
    GetCategorysByParentID(parentID){
this.loginService.GetCategorysByParentID(1,parentID).subscribe(data=>
    {
        data = JSON.parse(data['_body']);
        this.categorysList=JSON.parse(JSON.stringify(data));
       
    })

    }
    //Category list selection
    categoryChange(event)
    {
this.categoryID=event.target.value;

if(this.categoryID!==undefined || this.categoryID!=='0')
this.GetSubcategoryByID(this.categoryID);
    }
    //Sub Category list selection
    subCategoryChange(event)
    {
//this.subCategoryID=event.target.value;
this.subCategoryID=event.value;

// let filterSkills=this.subCategorysList.filter(x=>x.id==this.subCategoryID)
// if(filterSkills.length>0)
// {
    
//     this.subCategoryID=filterSkills[0].category;
// }


    }
    GetSubcategoryByID(categoryID)
    {
        this.loginService.GetCategorysByParentID(1,categoryID).subscribe(data=>
            {
                data = JSON.parse(data['_body']);
               let tempSubCategorys =JSON.parse(JSON.stringify(data));
               
               console.log(tempSubCategorys);
               if(tempSubCategorys.length>0)
               {
                
                this.subCategorysList=tempSubCategorys;
               }
               else{
                   this.subCategorysList=[];
               }
              
               
            })
        
    }

    
    //Cancel Collabo
    CancelCollabo(){
      
    }

    DeleteActorFromDynamic(actorid){
console.log(actorid);
console.log(this.selectedList);
      const index = this.dynamicArray.findIndex(user => user.id === actorid); 
this.dynamicArray.splice(index, 1); 
this.getSelectedActors
this.selectedList.splice(this.selectedList.indexOf(actorid), 1);

    //   console.log(actorid);
    //  let filterAtors=this.dynamicArray.filter(x=>x.id==actorid);
     

    // if (filterAtors.length>0) {

    
    //     this.dynamicArray.splice(index, 1);
    // }   
console.log(this.dynamicArray);
console.log(this.selectedList);
    }
    GoToStep2(tabype){
     
        console.log(tabype);
        console.log(this.collaboName)
        if(tabype=="step1")
        {this.tabtype=tabype;}
        else if(tabype=="step2")
        {
     if(this.collaboName==""||this.collaboName==undefined||this.categoryID==""||this.categoryID==undefined||!this.selectedList.length||this.selectedList==undefined||this.optionalTags==""||this.optionalTags==undefined||this.collaboDescription==""||this.collaboDescription==undefined)
    //  ||this.TitleName==""||this.TitleName==undefined
     {
      return;
     }
     else
      {
        this.tabtype=tabype;
      }
      }
      else if(tabype=="step3")
      {
   if(this.regionName==""||this.regionName==undefined||this.selectedList.length==0||this.checkdynamicarray==false||this.specificTimeLine==undefined||this.specificTimeLine=="")

   {
    // ||this.projectPeriod==""||this.projectPeriod==undefined||this.specificTimeLine==""||this.specificTimeLine==undefined||
    return;
   }
   else
    {
      this.tabtype=tabype;
    }
    }
    else if(tabype=="step4")
    {
      if(this.expectedBudget==""||this.expectedBudget==undefined||this.specificBudget==""||this.specificBudget==undefined)
      {
       return;
      }
      
      else
       {
         if(this.hourselect==true){
         let filterFees=this.dynamicArray.filter(val=>!val.fees || !val.fees );
         console.log(filterFees);
         if(filterFees.length>0)
         {return}
         }
         if(this.percentselect==true){
          let filterFees=this.dynamicArray.filter(val=>!val.percent );
          console.log(filterFees);
          if(filterFees.length>0)
          {return}
          }
          if(this.priceselect==true){
            let filterFees=this.dynamicArray.filter(val=>!val.fees );
            console.log(filterFees);
            if(filterFees.length>0)
            {return}
            }
         if((this.expectedBudget=="1" && this.specificBudget>500)||(this.expectedBudget=="2" && (this.specificBudget<501 ||  this.specificBudget>1000))||(this.expectedBudget=="3" && ((this.specificBudget<1001 ||  this.specificBudget>10000)))||(this.expectedBudget=="4" && (this.specificBudget<10001)))
        {
            // Swal.fire("Specific budget should be in the limits of Budget and cost")
            this.specificbudgeterror=true;
            return;
        }
        else if(this.checkpercentage==true)
        {
        
         return;
        }
        else if(this.checkpercentagesum==true)
        {
         
         return;
        }
        else if(this.checkbudget==true)
   {
    //Swal.fire("Specific budget should be in the limits of Budget and cost");
    return;
   }
         else if(this.totalfixedamt>this.specificBudget || this.totalhouramt> this.specificBudget || this.totalpercentamt>this.specificBudget)
         {
          this.totalamounterror=true;
           return;
         }
         else{
         this.tabtype=tabype;
         }
  }
     
       if(this.tabtype=="step4")
       {
         this.typeoffile="Legaldocuments";
         this.legalcollabo=true;
         this.displayfilename1=false;
       }
     
    }
  
      }
    //Goto previous step
    GoToPreviousSteps(tabType)
    {
        this.tabtype=tabType;
    }

     //drag
@HostListener("dragover", ["$event"]) onDragOver(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragend", ["$event"]) onDragEnd(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("drop", ["$event"]) onDrop(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
  event.stopPropagation();
  if(this.typeoffile=="Collabo")
  { 
    console.log(this.typeoffile)
     if (event.dataTransfer.files) {
    this.displayfilename=true;
    this.displayfilename1=true;
    let files: FileList = event.dataTransfer.files;
    console.log(files[0])
    console.log(files.length);
    console.log(files[0].type);
    this.filename=files[0].name
    console.log(files[0].type=="application/pdf");
    console.log(this.userID)
     if(files[0].type=="application/pdf"||"application/doc")
     {
    this.imagefile = this.loginService.filechange2(files[0],files.length,this.collaboID,this.typeoffile);
    console.log(this.imagefile);
    // if(param=="Collabo")
    // {
    //   console.log("collabo param")
    this.imageservice.ImageUplode.subscribe();
    this.collaboPath='Images/Collabo/'+this.userID+'/'+this.filename
    console.log(this.collaboPath)
    localStorage.setItem('collabopath',this.collaboPath);
      
    // }
    // else if(param.toString()=="Legaldocuments"){
    //   console.log("legaldocuments param")
    // this.imageservice.ImageUplode.subscribe(Img => this.uploadLegalDocuments = Img);
    // }
    
    console.log(this.collaboPath);
     }
     else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
     {
      this.imagefile = this.loginService.filechange2(files[0],files.length,this.collaboID,this.typeoffile);
      console.log(this.imagefile);
      // if(param=="Collabo")
      // {
      //   console.log("collabo param")
      this.imageservice.ImageUplode.subscribe();
      this.collaboPath='Images/Collabo/'+this.userID+'/'+this.filename
      console.log(this.collaboPath)
      localStorage.setItem('collabopath',this.collaboPath);
      
     }
  }
}
else if(this.typeoffile=="Legaldocuments")
{
  console.log(this.typeoffile)
  if (event.dataTransfer.files) {
    this.displayfilename=true;
    this.displayfilename1=true;
    let files: FileList = event.dataTransfer.files;
    console.log(files[0])
    console.log(files.length);
    console.log(files[0].type);
    this.filename1=files[0].name
    console.log(files[0].type=="application/pdf");
    console.log(this.userID)
     if(files[0].type=="application/pdf"||"application/doc")
     {
    this.imagefile = this.loginService.filechange2(files[0],files.length,this.collaboID,this.typeoffile);
    console.log(this.imagefile);
    this.imageservice.ImageUplode1.subscribe();
     this.uploadLegalDocuments='Images/Legaldocuments/'+this.userID+'/'+this.filename1
        localStorage.setItem('uploadlegaldocuments',this.uploadLegalDocuments);
     console.log(this.uploadLegalDocuments)
     }
     else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
     {
      this.imagefile = this.loginService.filechange2(files[0],files.length,this.collaboID,this.typeoffile);
      console.log(this.imagefile);
      // if(param=="Collabo")
      // {
      //   console.log("collabo param")
      this.imageservice.ImageUplode1.subscribe();
      this.uploadLegalDocuments='Images/Legaldocuments/'+this.userID+'/'+this.filename1
      console.log(this.uploadLegalDocuments)
      localStorage.setItem('uploadlegaldocuments',this.uploadLegalDocuments);
      
     }
  }
}
}

    onCheckboxChange(e,id)
    {
        console.log(e.target.value);
        console.log(id);
       this.checkid=e.target.value;
       
       
       this.selectedActors.push(this.checkid)
      
       this.typeOf('',this.checkid)
       
    }

    tabSelect(buttonSelection)
    {
      this.totalamounterror=false;
      console.log(buttonSelection)
this.butonType=buttonSelection;
if(buttonSelection=='hour'){
  this.totalfixedamt=0;
      this.totalpercentamt=0;
      this.hourselect=true
      this.percentselect=false;
      this.priceselect=false;
}
else if(buttonSelection=='price'){
  this.totalhouramt=0;
      this.totalpercentamt=0;
      this.priceselect=true
      this.percentselect=false;
      this.hourselect=false;
}
else if(buttonSelection=='percent'){
  this.totalfixedamt=0;
  this.totalhouramt=0;
  this.percentselect=true;
  this.hourselect=false;
  this.priceselect=false;
}
for(var i=0;i<this.dynamicArray.length;i++){
  this.dynamicArray[i].fees='';
  this.dynamicArray[i].hours='';
  this.dynamicArray[i].percent='';
}
    }

    // calculation for fixed price
typeOf1(id,fees)
    {
      var sum1=0
      this.totalpercentamt=0;
      this.totalhouramt=0;
      console.log(this.hoursFulltotal)
      let total=this.hoursFulltotal;
     
     const json={
       id:id,
       sum:fees
   }
   let totalhours=[];
   console.log(json)
   this.hourtotal.forEach((element,index)=>{
     console.log(element,index);
     if(element.id==id) 
     {
     console.log(this.hourtotal[index]);
     delete this.hourtotal[index];
     }
  });
    this.hourtotal.push(json);
    console.log(this.hourtotal);
    
      this.hoursFulltotal.push(json);
 
     console.log(this.hourtotal);
     console.log(this.hoursFulltotal);
 
     console.log(this.hourtotal)
    console.log(this.hourtotal.length);
     for(var i=0;i<this.hourtotal.length;i++){
       console.log(this.hourtotal[i])
       if(this.hourtotal[i]!==undefined)
       {
         sum1=sum1+this.hourtotal[i].sum
       }
     }
     this.totalfixedamt=sum1
     if(this.totalfixedamt>this.specificBudget)
     {
      this.totalamounterror=true;
     }
     else{
     this.totalamounterror=false;
     }
    }

    //calculation for hourly price
typeOf2(id,hours,fees)
    {
      this.totalfixedamt=0;
      this.totalpercentamt=0;
      var sum=0;
      var sum1=0
       
      console.log(this.hoursFulltotal)
      let total=this.hoursFulltotal;
     sum=hours*fees;
     
     const json={
       id:id,
       sum:sum
   }
   let totalhours=[];
   console.log(json)
   this.hourtotal.forEach((element,index)=>{
     console.log(element,index);
     if(element.id==id) 
     {
     console.log(this.hourtotal[index]);
     delete this.hourtotal[index];
     }
   
  });
    this.hourtotal.push(json);
    console.log(this.hourtotal);
    
      this.hoursFulltotal.push(json);
 
     console.log(this.hourtotal);
     console.log(this.hoursFulltotal);
 
     console.log(this.hourtotal)
    console.log(this.hourtotal.length);
     for(var i=0;i<this.hourtotal.length;i++){
       console.log(this.hourtotal[i])
       if(this.hourtotal[i]!==undefined)
       {
         sum1=sum1+this.hourtotal[i].sum
       }
     }
     this.totalhouramt=sum1
     if(this.totalhouramt>this.specificBudget)
     {
      this.totalamounterror=true;
    }
    else{
     this.totalamounterror=false;
     }
    }

    // claculation for percentage price
    roundTo(num, places) {
      var factor = 10 ** places;
      return Math.round(num * factor) / factor;
    }
    typeOf3(id,percent){
      var sum1=0
      var per=0
      var sum=0;
      var budget=0;
      this.totalfixedamt=0;
      this.totalhouramt=0;
      if(percent>100)
      {
        //Swal.fire("percentage value must be less than 100");
        this.checkpercentage=true;
        return;
      }
      else{
        this.checkpercentage=false;
      console.log(this.hoursFulltotal)
      let total=this.hoursFulltotal;
       budget=this.specificBudget
       sum=((percent/100)*budget)
     const json={
       id:id,
       sum:sum,
       percentage:percent,
   }
   let totalhours=[];
   console.log(json)
   this.hourtotal.forEach((element,index)=>{
     console.log(element,index);
     if(element.id==id) 
     {
     console.log(this.hourtotal[index]);
     delete this.hourtotal[index];
     }
   
  });
    this.hourtotal.push(json);
    console.log(this.hourtotal);
    
      this.hoursFulltotal.push(json);
 
     console.log(this.hourtotal);
     console.log(this.hoursFulltotal);
 
     console.log(this.hourtotal)
    console.log(this.hourtotal.length);
     for(var i=0;i<this.hourtotal.length;i++){
       console.log(this.hourtotal[i])
       if(this.hourtotal[i]!==undefined)
       {
        var ref=this.roundTo(this.hourtotal[i].sum,2);
        var percent1=this.hourtotal[i].percentage;
        console.log(ref);
         sum1=sum1+ref
         per=per+percent1
         console.log(sum1,per);
         if(per>100)
         {
           //Swal.fire("sum of percentages should not exceed 100")
           this.checkpercentagesum=true;
         }
         else{
          this.checkpercentagesum=false;
         }
       }
     }
     this.totalpercentamt=this.roundTo(sum1,2);
     if(this.totalpercentamt>this.specificBudget)
     {
      this.totalamounterror=true;
     }
     else{
      this.totalamounterror=false;
      }
    }
    }
    checkbudgetandcost(value)
{
  console.log(this.expectedBudget)
  console.log(value);
  if((this.expectedBudget=="1" && this.specificBudget>500)||(this.expectedBudget=="2" && (this.specificBudget<501 ||  this.specificBudget>1000))||(this.expectedBudget=="3" && ((this.specificBudget<1001 ||  this.specificBudget>10000)))||(this.expectedBudget=="4" && (this.specificBudget<10001)))
  {
      
      this.checkbudget=true;
      return;
  }
  else{
    this.checkbudget=false;
  }
}
calculatefee(){
      console.log(this.hoursfee)
    }
    //Checking no of actors
    typeOf(event,Id)
    {
        this.checkvalue=event.target.value;
      console.log(this.checkvalue);
      if(this.checkvalue!='')
      {
    this.checkdynamicarray=true;
      }
      else
      {
        this.checkdynamicarray=false;
      }
        const json={
          name:Id,
          value:this.checkvalue
        }
        this.jsonList.push(json);
              
              this.selectedactorsList=this.jsonList;
            console.log(this.selectedactorsList)
    }
     typeOfdesc(event,Id)
    {
      
        this.checkvalue=event.target.value;
       
      console.log(this.checkvalue,this.checkdynamicarray);
        const json={
          name:Id,
          description:this.checkvalue
        }
        this.jsonList.push(json);
              
             console.log(this.selectedactorsList);

    }
 //paying fees for actors
    PayActors(row){

const json={
    id:row.id,
    percentag:this.chkPercent,
    fees:this.chkFees
}
this.perentagefeesList.push(json);
    }

    Postcollabo(){
      this.postcollabo=true;
    }
    submitCollabo(){
      localStorage.setItem('CollaboPosted','true');
    
       this.collaboPath=localStorage.getItem('collabopath');
       this.uploadLegalDocuments=localStorage.getItem('uploadlegaldocuments')
    console.log(this.collaboPath,this.uploadLegalDocuments);
  
         if(this.skillID==undefined)
         this.skillID="";
 
         if(this.collaboPath==undefined)
         this.collaboPath="";
         
         if(this.uploadLegalDocuments==undefined)
         this.uploadLegalDocuments="";
         
         if(this.specificTimeLine==undefined)
         this.specificTimeLine="0";
 
         if(this.collaboID==undefined)
        {
         this.collaboID="";
         this.parentcollaboid="0";
         this.statusidParam="1";
        }
         else
        {
          this.parentcollaboid=this.collaboID;
          this.statusidParam="1";
        }
        console.log(this.collaboPath,this.uploadLegalDocuments)
      
         this.saveCollaboJson={
             idparam:this.cid,
 categoryparam:this.categoryID,
 subcatergoryparam:this.selectedList,
 nameparam:this.collaboName,
 descriptionparam:this.collaboDescription,
 expectedbudgetparam:this.expectedBudget,
 estimatedtimeparam:this.specificBudget,
 paytypeparam:this.butonType,
 statusparam:this.statusidParam,
 startdateparam:this.startDate,
 enddateparam:this.endDate,
 regionparam:this.regionName,
 skillidparam:this.optionalTags,
 collabopathparam:this.collaboPath,
 projectperiodparam:this.projectPeriod,
 specifictimelineparam:this.specificTimeLine,
 payvalueparam:this.payValue,
 
 legaldocumentpathparam:this.uploadLegalDocuments,
 collabofilename:this.filename,
 legaldocfilename:this.filename1,
 createdbyparam:'admin',
 updatedbyparam:'user',
 // actoridparam: this.selectedActors
 // actoridparam:this.selectedactorsList,
 // percentagesrowidparam:this.dynamicArray,
 actoridparam:"",
 percentagesrowidparam:"",
 Title:this.collaboName,
 userID:this.userID,
 actors:this.dynamicArray,
  parentcollaboid:this.parentcollaboid
 
         }
         console.log(this.saveCollaboJson);
         this.saveCollaboJson=JSON.stringify(this.saveCollaboJson)
         localStorage.setItem('collabojson',this.saveCollaboJson)
         localStorage.removeItem('collabopath');
         localStorage.removeItem('uploadlegaldocuments')
         this.router.navigateByUrl('/register');
 return;
         
     }
}
